var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_6_2",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38,39.6H8c-1.5,0-3-0.7-3.9-1.8c-1.8-2.3-1.5-5.5,0.6-7.3c2.3-1.9,3.6-4.8,3.6-7.8v-5.1 c0-6.7,4.6-12.5,10.9-14.2V3c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8v0.3c6.3,1.7,10.9,7.5,10.9,14.2v5.1c0,3,1.3,5.8,3.6,7.7 c1.2,1,1.9,2.4,1.9,4.1C43.2,37.3,40.9,39.6,38,39.6z M23.2,6.7L23.2,6.7L21.5,7c-5.2,0.8-9.2,5.3-9.2,10.6v5.1 c0,4.2-1.8,8.1-5,10.8c-0.5,0.4-0.5,1.2-0.1,1.7c0.2,0.2,0.5,0.3,0.8,0.3h30c0.7,0,1.2-0.5,1.2-1.2c0-0.6-0.3-0.8-0.4-0.9l-0.1-0.1 c-3.2-2.7-5-6.7-5-10.8v-5.1c0-5.3-4-9.9-9.2-10.6L23.2,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,46.8c-5,0-9.2-3.7-10.2-8.9l-0.4-2.4h21.2l-0.4,2.4C32.2,43.1,28,46.8,23,46.8z M17.6,39.5 c1.1,2,3.1,3.3,5.4,3.3c2.3,0,4.3-1.3,5.4-3.3H17.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLight);
export default __webpack_public_path__ + "static/media/NotificationLight.d07d6a76af70e64e5bf45d236d0840a3.svg";
export { ForwardRef as ReactComponent };